<script>
import { getFileTypeLogo } from '@/utils/modules/getStyles'

export default {
  name: 'FileBoxDialog',
  props: {
    headline: {
      type: String,
      default: ''
    },
    filename: {
      type: String,
      default: ''
    }
  },
  methods: {
    getFileTypeLogo
  }
}
</script>

<template>
  <div class="file-box-dialog pointer">
    <el-image class="file-img" :src="getFileTypeLogo(filename, 'small')" alt="file" fit="cover" />
    <p class="file-name h-line-1">{{ headline }}</p>
    <p class="file-icon"><i class="el-icon-arrow-right" /></p>
  </div>
</template>

<style lang="scss" scoped>
.file-box-dialog {
  width: 170px;
  height: 40px;
  background: #fff;
  // box-shadow: 0 3px 6px 0 rgba(7, 60, 0, 0.1);
  box-shadow: rgba(149, 157, 165, 0.2) 0px 1px 3px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding: 10px;
  box-sizing: border-box;
  .file-img {
    width: 20px;
    height: 20px;
  }
  .file-name {
    width: 100px;
    font-size: 13px;
    font-weight: 600;
    color: #000;
  }
  .file-icon {
    font-size: 16px;
    font-weight: 600;
    color: #BFBFBF;
  }
}
</style>
